import React from 'react';

/**
 * Centered card used by the login screen.
 */
const AuthCard = ({ children, footer }) => {
  return (
    <div className="min-vh-100 d-flex flex-column align-items-center px-3" style={{ paddingTop: '10vh' }}>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i className="bi bi-journal-text fs-4" aria-hidden="true"></i>
        <span className="fs-5 fw-semibold">Kira Wiki</span>
      </div>
      <div className="gh-box" style={{ width: '100%', maxWidth: '400px' }}>
        <div className="gh-box-body" style={{ padding: '28px' }}>{children}</div>
      </div>
      {footer && <div className="mt-3 text-muted-gh">{footer}</div>}
    </div>
  );
};

export default AuthCard;
